<template>
  <div class="navMenu">
    <label v-for="navMenu in navMenus" :key="navMenu">
      <el-menu-item v-if="navMenu.sub_children == null  " :data="navMenu" :index="navMenu.path + ''"
        @click="clickMenu(navMenu)">
        <i :class="navMenu.icon"></i>
        <span slot="title">{{ navMenu.name }}</span>
      </el-menu-item>
      <el-submenu v-if="navMenu.sub_children" :data="navMenu" :index="navMenu.path + ''"  >
        <template slot="title">
          <i :class="navMenu.icon"></i>
          <span> {{ navMenu.name }}</span>
        </template>
        <nav-menu :navMenus="navMenu.sub_children"></nav-menu>
      </el-submenu>
    </label>
  </div>
</template>

<script>
  export default {
    name: 'NavMenu',
    props: ['navMenus'],
    data() {
      return {}
    },
    created() {},
    methods: {
      goto(menu) {
        console.info(menu)
        const currentRoute = this.$route;
        const targetRoute = this.$router.resolve(menu).route;
        if (currentRoute.fullPath !== targetRoute.fullPath) {
          this.$router.push(targetRoute);
        }
      },
      clickMenu(navMenu) {
        this.$store.commit('selectMenu', navMenu)
      },
    }

  }
</script>

<style scoped>
  ::-webkit-scrollbar {
    display: none
    }
</style>



// WEBPACK FOOTER //
// src/components/Menulist.vue